export const PASSWORD_LENGTHS = Object.freeze({
  MIN: 10,
  MAX: 64,
})
